/*
 *
 * PlanAParty constants
 *
 */

export const DEFAULT_ACTION = '/PlanAParty/DEFAULT_ACTION';
export const SUBMIT_PLAN_A_PARTY = '/PlanAParty/SUBMIT_PLAN_A_PARTY';
export const FOOD_CHOICES = [
  {
    name: 'Veg',
    value: 'Veg',
  },
  {
    name: 'Non-Veg',
    value: 'Non-Veg',
  }];
export const ALCOHOL = [
  {
    name: 'Yes',
    value: 'Yes',
  },
  {
    name: 'No',
    value: 'No',
  }];
export const REST_TYPES = [
  {
    name: 'Luxury Dining',
    value: 'Luxury Dining',
    isChecked: false,
  },
  {
    name: 'Bars & Lounges',
    value: 'Bars & Lounges',
    isChecked: false,
  },
  {
    name: 'Casual Dining',
    value: 'Casual Dining',
    isChecked: false,
  },
  {
    name: 'Cafes',
    value: 'Cafes',
    isChecked: false,
  }];
export const PAYLOAD_SOURCE_KEY = 'plan_party';
export const MANDATORY_FIELDS = ['name', 'phone', 'email', 'date',
  //  'preferred_time',
  'city'];



// WEBPACK FOOTER //
// client/containers/PlanAParty/constants.js